"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOutstreamAd = void 0;
var getGenderTargeting_1 = __importDefault(require("../../ads-service/utils/targeting/getGenderTargeting"));
var getAgeTargeting_1 = __importDefault(require("../../ads-service/utils/targeting/getAgeTargeting"));
var includeAdMarkup_1 = __importDefault(require("../../../helpers/includeAdMarkup"));
/**
 * Retrieve outstream advertisement markup
 *
 * @param {object} storyGroup data for the current story
 * @param {object} user current user
 * @param {string} experience source of the ad experience
 * @param {string} unit name of ad unit
 * @param {number} timestamp timestamp for the ad request
 * @param {object} testGroups test groups
 * @returns {string} advertisement markup
 */
function getOutstreamAd(_a) {
    var _b;
    var storyGroup = _a.storyGroup, user = _a.user, experience = _a.experience, _c = _a.unit, unit = _c === void 0 ? "outstream_video" : _c, _d = _a.timestamp, timestamp = _d === void 0 ? Date.now() : _d, testGroups = _a.testGroups;
    var renderAd = (0, includeAdMarkup_1.default)(unit, testGroups, {
        user: user,
        story: __assign(__assign({}, storyGroup), { language: storyGroup.language.id }),
    });
    if (!renderAd.result) {
        return { renderAd: renderAd, markup: "" };
    }
    var category = (storyGroup === null || storyGroup === void 0 ? void 0 : storyGroup.category) || (storyGroup === null || storyGroup === void 0 ? void 0 : storyGroup.categories), language = ((_b = storyGroup === null || storyGroup === void 0 ? void 0 : storyGroup.language) === null || _b === void 0 ? void 0 : _b.id) || (storyGroup === null || storyGroup === void 0 ? void 0 : storyGroup.language), request = "".concat(experience, "_").concat(unit, "-").concat(timestamp), targeting = {
        KV3: (0, getGenderTargeting_1.default)(user) + "-" + (0, getAgeTargeting_1.default)(user),
    };
    if (storyGroup === null || storyGroup === void 0 ? void 0 : storyGroup.rating) {
        targeting["storyRating"] = storyGroup === null || storyGroup === void 0 ? void 0 : storyGroup.rating;
    }
    if (category) {
        targeting["category"] = category;
    }
    if (language) {
        targeting["language"] = language;
    }
    var targetingString = JSON.stringify(targeting);
    return {
        renderAd: renderAd,
        markup: "<div id=\"".concat(request, "\" class=\"advertisement ").concat(unit, "\" data-targeting=").concat(targetingString, " aria-label=\"Advertisement\"></div>"),
    };
}
exports.getOutstreamAd = getOutstreamAd;
exports.default = getOutstreamAd;
